/**
 * @generated SignedSource<<e4a73e702322cba180996701ba26bcd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkActiveEarnCashbackFidelity_charge$data = {
  readonly cashbackExclusive: {
    readonly percentage: number | null | undefined;
    readonly status: string | null | undefined;
    readonly value: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentLinkActiveEarnCashbackFidelity_charge";
};
export type PaymentLinkActiveEarnCashbackFidelity_charge$key = {
  readonly " $data"?: PaymentLinkActiveEarnCashbackFidelity_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveEarnCashbackFidelity_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkActiveEarnCashbackFidelity_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Cashback",
      "kind": "LinkedField",
      "name": "cashbackExclusive",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "beaf9e56d3e834a7c19af8046b60a5c0";

export default node;
